/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summary_Timing_Info_LabelInputs */



/**
* | output |
* | --- |
* | "Timing Information" |
*
* @param {Summary_Timing_Info_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const summary_timing_info_label = /** @type {((inputs?: Summary_Timing_Info_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Timing_Info_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Informations de synchronisation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitinformationen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Informazioni sui tempi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Информация о времени")
	if (locale === "es") return /** @type {LocalizedString} */ ("Información de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间信息")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイミング情報")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय संबंधी जानकारी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Informações sobre o tempo")
	return /** @type {LocalizedString} */ ("Timing Information")
});